import "./styles/index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import App from "./App.tsx";
// import theme from "./theme";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthenticationProvider } from "./Authentication/context/AuthenticationProvider.tsx";
import PopupProvider from "./context/Popup/PopupProvider.tsx";
import "react-datepicker/dist/react-datepicker.css";
// import { initialStyle } from "./theme/compStyleOverride.ts";
import ThemeProvider from "./context/ThemeProvider/ThemeProvider.tsx";
import PrintProvider from "./context/PrintProvider/PrintProvider.tsx";
import HL7MessageTriggerProvider from "./context/HL7MessageTrigger/HL7MessageTriggerProvider.tsx";
const queryClient = new QueryClient();

ReactDOM.createRoot(document.querySelector("#root")!).render(
  <ThemeProvider>
    <QueryClientProvider client={queryClient}>
      <PopupProvider>
        <PrintProvider>
          <AuthenticationProvider>
            <HL7MessageTriggerProvider>
              <App />
            </HL7MessageTriggerProvider>
          </AuthenticationProvider>
        </PrintProvider>
      </PopupProvider>
    </QueryClientProvider>
  </ThemeProvider>
);
